import { render, staticRenderFns } from "./FBButton.vue?vue&type=template&id=2d7a5cf8&scoped=true&"
import script from "./FBButton.vue?vue&type=script&lang=js&"
export * from "./FBButton.vue?vue&type=script&lang=js&"
import style0 from "./FBButton.vue?vue&type=style&index=0&id=2d7a5cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a5cf8",
  null
  
)

export default component.exports